module.exports = __webpack_public_path__ + "static/img/star.77f92803.svg";